import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../components/BannerOne";

// Images
import partnerProgramLogo from '../../assets/img/partnerProgram/banner.png';

// Scss
import '../../assets/css/partnerProgram.scss';

function NewPartnerPortal() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  const TITLE = "A new home for your Partner Portal";
  const SUB_TITLE = <div>
    <div className="mb-3">
    As a leader in modernization we’re always looking for ways to innovate to ensure our partners – like you – 
    are getting the best experience. 
    <br></br>
    So, we’ve re-mastered the portal to give you improved access to sales tools to help 
    land and expand new deals, 
    <br></br>
    grow your expertise through our training, personalize and execute marketing programs, 
    and of course register those PDRs!
    </div>
    <br></br>
    <b>Already a registered user?</b> 
    <br></br>
    Access and bookmark the new portal with your existing credentials. Access <a className="boxHeaderSubText underline" target="_parent" href="https://partners.dynatrace.com/">here</a>
    <br></br>
    <b>New around here?</b>
    <br></br>
    <div>
    It’s easy to register, get started <a className="boxHeaderSubText underline" target="_parent" href="https://partners.dynatrace.com/#/page/registration">here</a>.
    
    </div>
</div>;
  
//   Check our new partner portal !!!! (link para Zift)
// Already a registered user? Just use the same credentials on the new portal!
// Never registered? Register here and access the new portal easily!
// NOTE: Partners of the RFOs must still use this portal to create PDRs.

  return (
    <>
        <BannerOne hasNoButton={true} bannerImage={partnerProgramLogo} title={TITLE} subTitle={SUB_TITLE} withoutImage={true}/>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default NewPartnerPortal;

